import React from "react";
import PicturesShell from "../PicturesShell";
import VehicleNotAttachedGraphic from "../VehicleNotAttachedGraphic";

export default function VehicleNotAttachedScreen() {
  return (
    <PicturesShell mainClassName="pi-pictures-main--center">
      <div className="pi-pictures-status-card">
        <span className="pi-pictures-label">Photo upload</span>
        <div className="pi-pictures-status-card__animation pi-pictures-status-card__animation--vehicle">
          <VehicleNotAttachedGraphic />
        </div>
        <h1>Vehicle is not attached</h1>
        <p>
          This link is not related to your request. To submit your photos, please check your email and open the link we sent you.
        </p>
      </div>
    </PicturesShell>
  );
}
